import * as React from 'react';
import { AbstractReactFactory } from '@projectstorm/react-canvas-core';

import NodeWidget from '../nodeWidget/NodeWidget';
import { NodeModelTypeEnum } from '../enums';
import { AmmoniaAmmoniumSensorNodeModel } from './AmmoniaAmmoniumSensorNodeModel';
import { AmmoniaAmmoniumSensorNodeWidget } from './AmmoniaAmmoniumSensorNodeWidget';

export class AmmoniaAmmoniumSensorNodeFactory extends AbstractReactFactory {
  constructor(private isMainMap) {
    super(NodeModelTypeEnum.AmmoniaAmmoniumSensor);
    this.isMainMap = isMainMap;
  }

  generateModel() {
    return new AmmoniaAmmoniumSensorNodeModel();
  }

  nodeUI(event) {
    return (
      <AmmoniaAmmoniumSensorNodeWidget engine={this.engine} node={event.model} width={50} height={44} renderedOnMap />
    );
  }

  generateReactWidget(event) {
    return this.isMainMap ? (
      <NodeWidget entity={event.model.getEntity()} onDevices={event.model.getOnDevices()}>
        {this.nodeUI(event)}
      </NodeWidget>
    ) : (
      this.nodeUI(event)
    );
  }
}
